
import React from "react";
import "./CyberArkPAM.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function CyberarkPAM() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
          CyberArk PAM​
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container" id="Cyberark-PAM">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <div className="Oracle-AboutWrapp">
              <div className="leftImage">
                <img
                  src="images/SecuritySchools/CyberARK-PAM/AboutBanner.png"
                  alt=""
                  className="img-responsive"
                />
              </div>
              <div className="rightContent">
                <h2 className="SP-AboutHeading">
                  About the CyberArk PAM​​
                </h2>
                <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                </p>
              </div>
            </div>
            <div className="keyObjective-wrapper" id="Oracle-Objective">
              <h2 className="key-obj-heading">Key Objectives:</h2>
              <div className="obj-inner-row">
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/CyberARK-PAM/Icon-1.png"
                    alt="key-objectives-icon"
                  />
                  <p>
                  Participants will get the practical knowledge and technical skills to securely design, install, and configure the CyberArk Privileged Access Management (PAM)  Solution.​
                  </p>
                </div>
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/CyberARK-PAM/Icon-2.png"
                    alt="key-objectives-icon"
                  />
                  <p>
                  Participants will gain valuable hands-on experience installing CyberArk components, configuring Authentication Types, and System Integrations (SIEM, SMTP, NTP), using our step-by-step exercise guide, official product documentation, and a dedicated lab environment.
                  </p>
                </div>
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/CyberARK-PAM/Icon-3.png"
                    alt="key-objectives-icon"
                  />
                  <p>This course provides the participant with the knowledge and skills required to administer, monitor, and troubleshoot an existing PAM implementation.​​</p>
                </div>
                <div className="objectiveBox">
                  <img
                    src="images/SecuritySchools/CyberARK-PAM/Icon-3.png"
                    alt="key-objectives-icon"
                  />
                  <p>The course includes presentations on PAM architecture, password management, and PSM, along with software concepts including monitoring and troubleshooting.​​</p>
                </div>
              </div>
              <div className="Section3">
                <h2 className="preSection-Head">Prerequisites​</h2>
                <p className="purpleHead">Participants should have o good understanding on Java Fundamentals, Basic networking knowledge, Basic Windows administration knowledge​</p>
                <div className="trainingModeSection">
                    <p className="darkPurple">Training Mode:</p>
                    <p className="lightPurple">VILT+ Self-paced+Hands-On+assessment​</p>
                </div>
              </div>
              <div className="topics-Wrapp">
                <h2 className="topics-heading">Topics in focus</h2>
                <div className="topicSec-row">
                    <div className="outerBordered-Box">
                        <h3 className="topicTitle">Identity Management​</h3>
                        <ul className="topicDetails-List">
                            <li>Introduction to Identity Management​</li>
                            <li>Identity Management Process and Policies​</li>
                            <li>IAM Audit and Implementation​</li>
                            <li>IDM Technologies​</li>
                        </ul>
                    </div>
                    <div className="outerBordered-Box">
                        <h3 className="topicTitle">Access Management​</h3>
                        <ul className="topicDetails-List">
                            <li>Access Management Fundamentals​​</li>
                            <li>Authentications Protocols for Federation and SSO​​</li>
                            <li>Monitoring & Alerting​​</li>
                        </ul>
                    </div>
                    <div className="outerBordered-Box">
                        <h3 className="topicTitle">CyberArk Privileged Access Management Administration​​</h3>
                        <ul className="topicDetails-List">
                            <li>Introduction to PAM Administration​</li>
                            <li>User Management​</li>
                            <li>Policies and Platforms​</li>
                            <li>Access control to safes​</li>
                            <li>Accounts​</li>
                            <li>Dependents</li>
                            <li>Privileged Access Workflows​</li>
                            <li>Discovery and Onboarding​</li>
                            <li>Privileged Session Management​</li>
                            <li>Privileged Threat Analysis​</li>
                            <li>Reports</li>
                            <li>Self Hosted Architecture​</li>
                            <li>Backup and Restore​</li>
                            <li>Disaster Recovery</li>
                            <li>System Monitoring​</li>
                            <li>Troubleshooting​</li>
                        </ul>
                    </div>
                    <div className="outerBordered-Box">
                        <h3 className="topicTitle">CyberArk Privileged Access Management Install and Configure​</h3>
                        <ul className="topicDetails-List">
                        <li>Core PAS-Review​</li>
                            <li>The Vault​</li>
                            <li>CPM / PVWA​</li>
                            <li>Integrations​</li>
                            <li>Authentication Methods​</li>
                            <li>Pre-Implementation</li>
                            <li>PSM​</li>
                            <li>PSM Load Balancing​</li>
                            <li>PSM for SSH Servers​</li>
                            <li>Securing CyberArk​</li>
                            <li>Vault Availability DR​</li>
                            <li>Vault Availability Cluster​</li>
                            <li>EPV Configuration - Performance Tuning​</li>
                        </ul>
                    </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default CyberarkPAM;

